<template>
    <FormModal :model="model" :init="init" modal-id="form">
        <template>
            <div :key="key" class="d-flex">
                <b-badge
                    :variant="$store.getters['form/status2variant'](model.status)"
                    class="align-self-center mr-1"
                    >
                    {{
                    trans.labels[
                    'forms.status.' + model.status
                    ]
                    }}
                </b-badge>
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <b-form-group
                    label-cols-sm="2"
                    label="状態"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-radio-group v-model="model.status" size="sm">
                        <b-form-radio value="pending">準備</b-form-radio>
                        <b-form-radio value="activated">受付</b-form-radio>
                        <b-form-radio value="closed">締切</b-form-radio>
                    </b-form-radio-group>
                    <input-error :errors="error.status" />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="公開"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-select
                        v-model="model.is_public"
                        size="sm"
                        >
                        <b-form-select-option :value="false">限定公開（URLを知っているのみアクセス）</b-form-select-option>
                        <b-form-select-option :value="true">公開（フォーム一覧からアクセス）</b-form-select-option>
                    </b-form-select>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="名前"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-row>
                        <b-col>
                            <b-form-input
                                v-model="model.name"
                                size="sm"
                                placeholder="フォーム１"
                                ></b-form-input>
                            <input-error :errors="error.name" />
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="概要（常時）"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-row>
                        <b-col>
                            <b-form-textarea
                                v-model="model.description"
                                size="sm"
                                placeholder=""
                                rows="3"
                                max-rows="6"
                                ></b-form-textarea>
                            <input-error :errors="error.description" />
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="概要（完了時）"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-row>
                        <b-col>
                            <b-form-textarea
                                v-model="model.description_completed"
                                size="sm"
                                placeholder=""
                                rows="3"
                                max-rows="6"
                                ></b-form-textarea>
                            <input-error :errors="error.description_completed" />
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="制限"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-row>
                        <b-col>
                            <small>最大人数</small>
                            <b-form-input
                                v-model="model.limits_maximum"
                                size="sm"
                                ></b-form-input>
                            <input-error :errors="error.limits_maximum" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <small>受付開始</small>
                            <b-form-input
                                v-model="model.limits_opened_at"
                                size="sm"
                                type="datetime-local"
                                ></b-form-input>
<!--
                            <BaseDatePicker
                                v-model="model.opened_at"
                                size="sm"
                                >
                            </BaseDatePicker>
-->
                            <input-error :errors="error.limits_opened_at" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <small>受付終了</small>
                            <b-form-input
                                v-model="model.limits_closed_at"
                                size="sm"
                                type="datetime-local"
                                ></b-form-input>
                            <input-error :errors="error.limits_closed_at" />
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="決済"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-row>
                        <b-col>
                            <small>代行会社</small>
                            <b-form-select
                                v-model="model.payment_provider"
                                size="sm"
                                >
                                <b-form-select-option :value="null"></b-form-select-option>
                                <b-form-select-option value="payjp">Pay.jp</b-form-select-option>
                            </b-form-select>
                            <input-error :errors="error.payment_provider" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <small>公開鍵</small>
                            <b-form-input
                                v-model="model.payment_key_public"
                                size="sm"
                                ></b-form-input>
                            <input-error :errors="error.payment_key_public" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <small>秘密鍵</small>
                            <b-form-input
                                v-model="model.payment_key_secret"
                                size="sm"
                                type="password"
                                ></b-form-input>
                            <input-error :errors="error.payment_key_secret" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <small>銀行振込</small>
                            <b-form-textarea
                                v-model="model.payment_bank_account"
                                size="sm"
                                placeholder=""
                                rows="3"
                                max-rows="6"
                                ></b-form-textarea>
                            <input-error :errors="error.payment_bank_account" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <small>価格</small>
                            <b-form-input
                                v-model="model.payment_price"
                                size="sm"
                                ></b-form-input>
                            <small class="text-muted">PhpSpreadsheetの計算式が利用可能</small>
                            <input-error :errors="error.payment_price" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <small>返金対応</small>
                            <b-form-select
                                v-model="model.payment_is_refundable"
                                size="sm"
                                >
                                <b-form-select-option :value="false">返金しない</b-form-select-option>
                                <b-form-select-option :value="true">キャンセル時に返金</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="アクセス制限"
                    description="ユーザー名だけでも機能します。"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <template>
                    </template>

                    <b-row>
                        <b-col>
                            <small>ユーザー名</small>
                            <b-form-input
                                v-model="model.auth_username"
                                size="sm"
                                ></b-form-input>
                            <input-error :errors="error.auth_username" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <small>パスワード</small><br>
                            <b-form-input
                                v-model="model.auth_password"
                                size="sm"
                                type="password"
                                ></b-form-input>
                            <input-error :errors="error.auth_password" />
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="連絡先"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-row>
                        <b-col>
                            <b-form-textarea
                                v-model="model.contact"
                                size="sm"
                                placeholder=""
                                rows="3"
                                max-rows="6"
                                ></b-form-textarea>
                            <input-error :errors="error.contact" />
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="フィールド"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <BaseEditor
                        v-model="model.fields"
                        >
                    </BaseEditor>
                    <input-error :errors="error.json" />
                </b-form-group>
            </template>
            <template v-else>
                <div class="mb-3">
                    <FormBadges :model="model" class="mb-1" />
                
                    <p>
                        {{ model.name }}
                        <b-link :href="`/f/${auth_uuid}/${model.uuid}`" target="_blank">
                            <font-awesome-icon class="fa-fw" icon="external-link-alt" />表示する
                        </b-link>
                    </p>

                    <p>
                        <strong>概要（常時）</strong><br>
                        {{ model.description }}
                    </p>

                    <p>
                        <strong>概要（完了時）</strong><br>
                        {{ model.description_completed }}
                    </p>

                    <p>
                        <strong>制限</strong><br>
                        最大人数: 
                        0
                        <template v-if="model.limits_maximum">
                        / {{ model.limits_maximum }}
                        </template>
                        <br/>
                        受付開始: 
                        <template v-if="model.limits_opened_at">
                            {{ model.limits_opened_at | baseDatetimeFormatter }}
                        </template>
                        <template v-else>
                            -
                        </template>
                        <br/>
                        受付締切: 
                        <template v-if="model.limits_closed_at">
                            {{ model.limits_closed_at | baseDatetimeFormatter }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </p>
                    <p>
                        <strong>クレジット決済</strong><br/>
                        <template v-if="model.payment_provider">
                            代行会社: {{ model.payment_provider }}<br>
                            公開鍵: {{ model.payment_key_public }}<br>
                            秘密鍵: 非表示<br>
                        </template>
                        <template v-else>
                            なし<br>
                        </template>
                        <br>

                        <strong>口座振込</strong><br/>
                        <template v-if="model.payment_bank_account">
                            {{ model.payment_bank_account }}<br>
                        </template>
                        <template v-else>
                            なし<br>
                        </template>
                        <br>

                        <strong>価格</strong><br/>
                        <template v-if="model.payment_price">
                            {{ model.payment_price }} 円<br>
                        </template>
                        <template v-else>
                            無料<br>
                        </template>
                        <br>

                        <strong>返金対応</strong><br/>
                        <template v-if="model.payment_is_refundable">
                            キャンセル時に返金可能<br>
                        </template>
                        <template v-else>
                            非対応<br>
                        </template>
                    </p>
                    <p>
                        <strong>アクセス制限</strong><br/>
                        ユーザー名: {{ model.auth_username }}<br>
                        パスワード: 非表示<br>
                    </p>
                    <p>
                        <strong>連絡先</strong><br/>
                        <template v-if="model.contact">
                            {{ model.contact }}<br>
                        </template>
                        <template v-else>
                            なし<br>
                        </template>
                        <br>
                    </p>

                    <hr class="py-5">

                    <p>※メールアドレスと名前は自動で追加されます。</p>

                    <BaseEditor
                        v-model="model.fields"
                        :editable="false"
                        />
                </div>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import FormBadges from '@/components/FormBadges.vue'
import InputError from '@/components/InputError.vue'

export default {
    components: {
        FormModal,
        FormBadges,
        InputError,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'trans',
        ])
    },
    mounted() {},
    methods: {},
}
</script>

<style lang="scss" scoped></style>


